import { render, staticRenderFns } from "./BAEventShare.vue?vue&type=template&id=11a818b5&"
import script from "./BAEventShare.vue?vue&type=script&lang=ts&"
export * from "./BAEventShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports